// extracted by mini-css-extract-plugin
export default {"wrapper":"ItemPrev_wrapper__9j9f-"};